module.exports = __webpack_public_path__ + "static/media/decoracao_04.d8dd68a5.jpg";